import { DateTime } from "luxon";

const toDateTimeFn = (value) => {
  if (!value) {
    return value;
  }
  return DateTime.fromISO(value).toLocaleString(
    DateTime.DATETIME_SHORT_WITH_SECONDS
  );
};

const timestampToDateTimeFn = (value) => {
  const zone = "America/Chicago";
  if (!value) {
    return "Unavailable";
  }
  return DateTime.fromMillis(value * 1000, { zone }).toFormat(
    "MM/dd/yyyy hh:mm a"
  );
};

const timestampToRelativeTimeFn = (value) => {
  const zone = "America/Chicago";
  if (!value) {
    return "Unavailable";
  }
  return DateTime.fromMillis(value * 1000, { zone }).toRelative();
};

export default {
  toDateTime: toDateTimeFn,
  timestampToDateTime: timestampToDateTimeFn,
  timestampToRelativeTime: timestampToRelativeTimeFn,
};
